module.exports = __webpack_public_path__ + "static/nornikel-69cdea7a2f57a860800124376cbc9975.jpg";